interface AchievementBadgeProps {
  icon: string;
  label: string;
  unlocked?: boolean;
}

export function AchievementBadge({ icon, label, unlocked = false }: AchievementBadgeProps) {
  return (
    <div className="flex flex-col items-center gap-2 w-20 text-center flex-shrink-0">
      <div className={`flex h-20 w-20 items-center justify-center rounded-full ${
        unlocked
          ? 'bg-primary/20'
          : 'bg-gray-200 dark:bg-white/10'
      }`}>
        <span className={`material-symbols-outlined text-4xl ${
          unlocked
            ? 'text-primary'
            : 'text-gray-400 dark:text-gray-500'
        }`}>
          {icon}
        </span>
      </div>
      <p className={`text-xs font-medium leading-snug ${
        unlocked
          ? 'text-gray-900 dark:text-white'
          : 'text-gray-500 dark:text-gray-400'
      }`}>
        {label}
      </p>
    </div>
  );
}
